// extracted by mini-css-extract-plugin
export var contractIcon = "richTextDisclosure-module--contract-icon--b81e7";
export var disclosureContent = "richTextDisclosure-module--disclosure-content--72ff4";
export var expandIcon = "richTextDisclosure-module--expand-icon--03b1c";
export var iconVisible = "richTextDisclosure-module--icon-visible--a43da";
export var richTextDisclosure = "richTextDisclosure-module--rich-text-disclosure--eafcf";
export var summary = "richTextDisclosure-module--summary--d314b";
export var summaryIconWrapper = "richTextDisclosure-module--summary-icon-wrapper--c0342";
export var summaryText = "richTextDisclosure-module--summary-text--191ac";